import React, { useState } from 'react';

export default function ShareModal({ onClose, onShareByEmail, onCopyLink, savedBuild, productDetails }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleShareByEmail = () => {
    onShareByEmail();
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(savedBuild.productURL + '?build-id=' + savedBuild.id);
      // You could add a toast notification here
    } catch (error) {
      console.error('Failed to copy link:', error);
    }
  };

  const handleSocialShare = (platform) => {
    const shareURL = savedBuild.productURL + '?build-id=' + savedBuild.id;
    const title = savedBuild.buildName;

    let url = '';
    switch (platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareURL)}&t=${encodeURIComponent(title)}`;
        break;
      case 'linkedin':
        url = `http://www.linkedin.com/shareArticle?url=${encodeURIComponent(shareURL)}&title=${encodeURIComponent(title)}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank', 'width=600,height=400');
  };

  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">Share This Build?</h2>
      </div>
      <div className="modal-body saveBuildModalBody">
        <button
          type="button"
          className="share-button"
          onClick={() => handleSocialShare('facebook')}
          data-action-type="share"
          data-share-method="facebook"
        >
          <em className="bi bi-facebook"></em>
          <span>Facebook</span>
        </button>

        <button
          type="button"
          className="share-button"
          onClick={() => handleSocialShare('linkedin')}
          data-action-type="share"
          data-share-method="linkedin"
        >
          <em className="bi bi-linkedin"></em>
          <span>LinkedIn</span>
        </button>

        <button className="share-button" onClick={handleShareByEmail} data-action-type="share" data-share-method="email">
          <em className="bi bi-envelope-fill"></em>
          <span>Email</span>
        </button>

        <button className="share-button" onClick={handleCopyLink} data-action-type="share" data-share-method="copy_link">
          <em className="bi bi-files"></em>
          <span>Copy Link</span>
        </button>
      </div>
    </>
  );
}